export default __webpack_public_path__ + "static/media/monitor(1).c56823ee.svg";